const normalizeToLen = (value, len) => {
    if (!value) {
      return value;
    }
  
    if (value.length <= len) {
      return value;
    }
  };
  
  export default normalizeToLen;